import React from "react";
import {Button, ButtonProps} from "@mui/material";

const CustomButton = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    return <Button ref={ref} {...props} variant="contained"/>;
});

export default CustomButton;